// packages/api-client/src/services/admin/adminFinanceService.ts

import { getApiClient } from '../../client';
import { handleApiError } from '../../utils/handleApiError';
import type { ServiceResponse } from '@dopomogai/types';

// --- TYPE DEFINITIONS (matching the backend response) ---

export interface MonobankAccount {
  id: string;
  type: 'black' | 'white' | 'fop' | string; // 'fop' is for corporate accounts
  currencyCode: number; // 980=UAH, 840=USD, 978=EUR
  balance: number; // Backend already converted this to major units (e.g., 12345.67)
  creditLimit: number;
  maskedPan: string[];
}

export interface MonobankClientInfo {
  clientId: string;
  name: string;
  accounts: MonobankAccount[];
}

export interface BalanceSnapshot {
    created_at: string; // ISO date string
    account_type: string;
    balance: number;
    currency_code: number;
}


export const adminFinanceService = {
    /**
     * Fetches current Monobank balance and client info from the backend.
     */
    getCurrentBalance: (): ServiceResponse<MonobankClientInfo> => {
      const url = '/admin/finance/balance';
      return getApiClient().get<MonobankClientInfo>(url)
        .then(res => res.data)
        .catch(err => handleApiError(err, 'fetching current Monobank balance'));
    },
  
    /**
     * Fetches historical balance snapshots for analytics charts.
     */
    getBalanceHistory: (): ServiceResponse<BalanceSnapshot[]> => {
      const url = '/admin/finance/balance-history';
      return getApiClient().get<BalanceSnapshot[]>(url)
        .then(res => res.data)
        .catch(err => handleApiError(err, 'fetching balance history'));
    },
  };